import React from 'react';
import {ApolloClient} from 'apollo-client';
import {InMemoryCache} from 'apollo-cache-inmemory';
import {createUploadLink} from 'apollo-upload-client';
import {onError} from 'apollo-link-error';
import {ApolloLink, Observable} from 'apollo-link';
import {ApolloProvider} from 'react-apollo';
import {ApolloProvider as ApolloHooksProvider} from 'react-apollo-hooks';
import {useAuth} from './AuthContext';

function AppApolloProvider(props) {
  const {logout, getAuthToken} = useAuth();

  const client = new ApolloClient({
    link: ApolloLink.from([
      onError(({graphQLErrors, networkError}) => {
        if (graphQLErrors) {
          graphQLErrors.forEach(({message, locations, path}) =>
            console.log(
              `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
            ),
          );

          if (
            graphQLErrors.some(({message}) =>
              message.includes('not accessible'),
            )
          ) {
            logout();
          }
        }

        if (networkError) console.log(`[Network error]: ${networkError}`);
      }),
      new ApolloLink(
        (operation, forward) =>
          new Observable(observer => {
            let handle;
            Promise.resolve(operation)
              .then(oper => {
                oper.setContext({
                  headers: {
                    Authorization: getAuthToken(),
                  },
                });
              })
              .then(() => {
                handle = forward(operation).subscribe({
                  next: observer.next.bind(observer),
                  error: observer.error.bind(observer),
                  complete: observer.complete.bind(observer),
                });
              })
              .catch(observer.error.bind(observer));

            return () => {
              if (handle) handle.unsubscribe();
            };
          }),
      ),

      new createUploadLink({
        uri:
          process.env.NODE_ENV === 'production'
            ? process.env.REACT_APP_IS_DEMO === '1'
              ? 'https://plum-demo.herokuapp.com/graphql'
              : 'https://plum-core.appspot.com/graphql'
            : 'http://localhost:3000/graphql',
      }),
    ]),
    cache: new InMemoryCache(),
  });

  return (
    <ApolloProvider client={client}>
      <ApolloHooksProvider client={client}>
        {props.children}
      </ApolloHooksProvider>
    </ApolloProvider>
  );
}

export {AppApolloProvider as ApolloProvider};
